import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useContextHook } from 'use-context-hook';
import { AuthContext } from './context/authContext';
import Login from './pages/login';
import Pages from './pages';

function PublicRoute({ children, redirectTo, isLoggedIn }) {
  return isLoggedIn ? <Navigate to={redirectTo} /> : children;
}

function PrivateRoute({ children, redirectTo, isLoggedIn }) {
  return isLoggedIn ? children : <Navigate to={redirectTo} />;
}
function Router() {
  const { isLoggedIn } = useContextHook(AuthContext, {
    isLoggedIn: 1,
  });
  return (
    <Routes>
      <Route
        path="/admin/:view"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Pages />
          </PrivateRoute>
        }
      />
      <Route
        path="*"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo="/admin/dashboard">
            <Login />
          </PublicRoute>
        }
      />
    </Routes>
  );
}

export default Router;
